import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Accordion } from 'react-bootstrap'
import ReactPlayer from 'react-player'
import CourseTitle from '../CourseTitle/CourseTitle'
import Style from './CourseDetail.module.css'
const CourseDetail = ({data}) => {
    return (
        <div className='pageHolder'>
            <section className={Style.DivisonCourse}>
                <img className={Style.CourseImage} src={`https://cdn.electronicsteps.ir/course/cover/${data.cover}.jpg`} alt="Package" />
                <h3> {data.name}</h3>
                
                <div className={`w-100`} dangerouslySetInnerHTML={{__html: data.description}}></div>
                
            </section>
            <Accordion  className={Style.AcaredonHolder}>
            <Accordion.Item  eventKey='0' className='w-100'>
                <Accordion.Header  className={Style.AccordionHeader}><h4 className={Style.TitleHolder}><div><p>0</p>معرفی دوره</div> <p className={Style.arrowHolder}><FontAwesomeIcon icon={faArrowDown}/></p></h4></Accordion.Header>
                <Accordion.Body>
                <ReactPlayer
                    url={`https://cdn.electronicsteps.ir/course/video/${data.video}.mp4`}
                    controls
                    width={'100%'}
                    height={'100%'}
                    />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            {
                data.segment.map((item,index)=>{
                    return(
                        <CourseTitle key={index} items={item} index={index+1}/>
                    )
                })
            }
        </div>
    )
}

export default CourseDetail
